/**
 * The Bookbase mark (public/icon.svg, also wired as favicon/PWA icon in index.html and
 * public/manifest.webmanifest): a dark #141414 rounded square, green #23fd9b book
 * shelves, white "B". Shared so the sign-in page, portal header, and the console's
 * TopNavigation identity all render the exact same asset -- never inline a copy.
 */
export function BookbaseLogo({ size = 32, className = "", alt = "Bookbase" }: { size?: number; className?: string; alt?: string }) {
  return <img src="/icon.svg" width={size} height={size} alt={alt} className={className} />;
}
